(function () {
  'use strict';

  moduleConfig.registerModule('eclipseApp.myAccount', ['eclipseApp.core', 'dtmService.module']);
})();
